"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentKeys = void 0;
var ContentKeys;
(function (ContentKeys) {
    ContentKeys["BenefitsList"] = "page-content.benefit-list";
    ContentKeys["BlogList"] = "page-blog.blog-list";
    ContentKeys["BlogPreviewList"] = "page-blog.blog-preview-list";
    ContentKeys["BranchList"] = "page-branches.branch-list";
    ContentKeys["BranchSlider"] = "page-branches.branch-slider";
    ContentKeys["CompanyLocationsListItem"] = "page-content.company-location-list";
    ContentKeys["CompetenceList"] = "page-services.competence-list";
    ContentKeys["DownloadList"] = "page-downloads.download-list";
    ContentKeys["DownloadListSelected"] = "page-downloads.download-list-selected";
    ContentKeys["EmployerTestimonialList"] = "page-content.employer-testimonal-list";
    ContentKeys["HomepageList"] = "page-homepage.homepage-list";
    ContentKeys["ImageBoxList"] = "page-content.image-box-list";
    ContentKeys["JobList"] = "page-jobs.job-list";
    ContentKeys["Jumbotron"] = "page-content.jumbotron";
    ContentKeys["RecruitmentList"] = "recruitment.recruitment-list";
    ContentKeys["RelevantBranches"] = "page-branches.relevant-branches";
    ContentKeys["RelevantServices"] = "page-services.relevant-services";
    ContentKeys["ServiceList"] = "page-services.service-list";
    ContentKeys["ServiceSlider"] = "page-services.service-slider";
    ContentKeys["Tab"] = "page-content.tab";
    ContentKeys["Teaser"] = "page-content.teaser";
    ContentKeys["Text"] = "page-content.text";
    ContentKeys["TextWithImage"] = "page-content.text-with-image";
    ContentKeys["TextWithList"] = "page-content.text-with-list";
    ContentKeys["TextWithListItem"] = "page-content.text-with-list-item";
    ContentKeys["TextWithVideo"] = "page-content.text-with-video";
})(ContentKeys = exports.ContentKeys || (exports.ContentKeys = {}));
